<div class="no-webgl-warning" data-map-nowebgl-warning="">
    <p class="no-webgl-warning__title">Notre carte des prix ne peut pas s’afficher sur votre navigateur !</p>
    <p class="no-webgl-warning__text">
        Pour voir cette carte, n’hésitez pas à télécharger un navigateur plus récent. <a href="https://www.google.fr/chrome/browser/desktop/">Chrome</a>, <a href="https://www.mozilla.org/fr/firefox/new/">Firefox</a> vous garantiront une expérience optimale sur notre site.
    </p>
</div>
